import { Field } from "../../field";
import { Merchant } from "../../merchant";
import { AveTimeToShip, MerchantField } from "../../types";

export class AveTimeToShipField extends Field<AveTimeToShip> {
  constructor(
    model: Merchant,
    opts: Partial<MerchantField<AveTimeToShip>> = {}
  ) {
    super(model, {
      dataType: "string",
      propertyName: "aveTimeToShip",

      uiFieldType: "Select",
      ...opts,
    });
  }

  get applicable(): boolean {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;
    const salesChannel = this._model.storeDetails.salesChannel.value;

    if (
      registeredCountry === "United Kingdom" ||
      registeredCountry === "United States" ||
      registeredCountry === "Canada"
    ) {
      return true;
    }

    if (
      (registeredCountry === "Australia" ||
        registeredCountry === "New Zealand") &&
      (salesChannel === "Online and In-store" || salesChannel === "Online Only")
    ) {
      return true;
    }
    return false;
  }

  get pickList(): AveTimeToShip[] {
    return [
      "Less than one week",
      "Less than two weeks",
      "Less than one month",
      "More than one month",
      "More than 3 months",
    ];
  }

  get testValue(): any {
    return "Less than one week";
  }

  get required(): boolean {
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }
}
